export function useConvertTime() {
    
      function timeToText(time) {
        const currenthours = time.getHours();
        const currentminutes = time.getMinutes();
        let currentminutestext = currentminutes.toString();
  
        if (currentminutes < 10) {
          currentminutestext = '0'.concat(currentminutestext);
        }
        let texttime = (currenthours - 12).toString().concat(':', currentminutestext, ' pm');
        if (currenthours <= 12) {
          if (currenthours < 10 && currenthours > 0) {
            texttime = '0'.concat(currenthours.toString(), ':', currentminutestext, ' am');
          } else {
            if (currenthours === 10 || currenthours === 11) {
              texttime = currenthours.toString().concat(':', currentminutestext, ' am');
            } else {
              if (currenthours === 0) {
                texttime = '12'.concat(':', currentminutestext, ' am');
              } else {
                texttime = '12'.concat(':', currentminutestext, ' pm');
              }
            }
          }
        } else {
          if (currenthours < 22) {
            texttime = '0'.concat((currenthours - 12).toString(), ':', currentminutestext, ' pm');
          }
        }
        return texttime;
      }
      
      function convertTime(texttime) {
        let hours = Number(texttime.substr(0, texttime.length - 6));
        let timedecimal = hours + Number(texttime.substr(3, 2)) / 60;
        if ('pm' === texttime.substr(texttime.length - 2) && hours < 12) {
          timedecimal += 12;
        }
        return timedecimal;
      }
      return {
        timeToText,
        convertTime,
      };
    }
  